import { Record } from "../fable_modules/fable-library-js.4.18.0/Types.js";
import { record_type, string_type } from "../fable_modules/fable-library-js.4.18.0/Reflection.js";

export class DayjsLongDateFormat extends Record {
    constructor(L) {
        super();
        this.L = L;
    }
}

export function DayjsLongDateFormat_$reflection() {
    return record_type("Loop54.Portal.WebUI.Interop.DayjsLongDateFormat", [], DayjsLongDateFormat, () => [["L", string_type]]);
}

export class DayjsConfig extends Record {
    constructor(formats) {
        super();
        this.formats = formats;
    }
}

export function DayjsConfig_$reflection() {
    return record_type("Loop54.Portal.WebUI.Interop.DayjsConfig", [], DayjsConfig, () => [["formats", DayjsLongDateFormat_$reflection()]]);
}

